/**
 * @generated SignedSource<<22acbbce91eeda09ca127562ce5717eb>>
 * @relayHash ada6fc6976ca8c58837727bbb4c2aa54
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b44ae9ca787b5c1babc01eaadbf9f1c689bee6baa7d14f132053afed2f7b875c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HelpCenterSettingsEmailEntryPointQuery } from './HelpCenterSettingsEmailEntryPointQuery.graphql';

const node: PreloadableConcreteRequest<HelpCenterSettingsEmailEntryPointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b44ae9ca787b5c1babc01eaadbf9f1c689bee6baa7d14f132053afed2f7b875c",
    "metadata": {},
    "name": "HelpCenterSettingsEmailEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
